export class CertificateModelV2 {
  label: string = "";
  details: string = "";
  expiryDate: string = "";
  auditDate: string = "";
  certifier: string = "";
  checked: boolean = false;

  constructor(certificateName: string, details: string) {
    this.label = certificateName;
    this.details = details;
  }

  setChecked(newChecked: boolean): void {
    this.checked = newChecked;
    if (!this.checked) {
      this.expiryDate = "";
      this.expiryDate = "";
      this.auditDate = "";
      this.certifier = "";
    }
  }

  toAnswerModel(): AnswerCertificateModelV2 {
    return new AnswerCertificateModelV2(
      this.label,
      this.expiryDate,
      this.auditDate,
      this.checked,
      this.certifier
    );
  }
}

export class AnswerCertificateModelV2 {
  label: string;
  expiryDate: string;
  auditDate: string;
  checked: boolean;
  certifier: string;

  constructor(
    label: string,
    expiryDate: string,
    auditDate: string,
    checked: boolean,
    certifier: string
  ) {
    this.label = label;
    this.expiryDate = expiryDate;
    this.auditDate = auditDate;
    this.checked = checked;
    this.certifier = certifier;
  }
}
